var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsTaskService, Task, TaskTemplate } from './task.service';
import { AlertModalService } from '../../../../component/alertmodal/alertmodal.service';
import { ValidationService } from '../../../../service/validation.service';
var KtsTaskComponent = /** @class */ (function (_super) {
    __extends(KtsTaskComponent, _super);
    function KtsTaskComponent(router, route, logger, action, message, page, service, alertModalService, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.alertModalService = alertModalService;
        _this.validService = validService;
        _this.toggles = {};
        _this.items = {};
        _this.deleteItems = {};
        _this.seq = 1;
        _this.readonly = false;
        _this.deleteFlg = false;
        _this.step = [];
        _this.taskType = [];
        _this.inspection = [];
        return _this;
    }
    KtsTaskComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.getType();
        this.setCompRec();
        this.toggles = {};
        for (var i = 1; i <= 5; i++) {
            this.toggles[i] = false;
        }
    };
    KtsTaskComponent.prototype.switchToggle = function (step) {
        this.toggles[step] = !this.toggles[step];
    };
    KtsTaskComponent.prototype.getType = function () {
        var _this = this;
        this.service.getType('CONSTRUCTION_STEP').subscribe(function (rec) { return _this.step = rec; });
        this.service.getType('TASK_TEMPLATE_TYPE').subscribe(function (rec) {
            var option = [];
            var inspection = [];
            for (var _i = 0, rec_1 = rec; _i < rec_1.length; _i++) {
                var r = rec_1[_i];
                if (r.code === 'inspection') {
                    inspection.push(r);
                }
                else {
                    option.push(r);
                }
            }
            _this.taskType = option;
            _this.inspection = inspection;
        });
    };
    KtsTaskComponent.prototype.onMsg = function (msg) {
        this.taskTemplate = new TaskTemplate(msg, this.readonly);
    };
    KtsTaskComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsTaskComponent.prototype.onSubscribe = function (data) {
        if (typeof data.project_m_id !== 'undefined') {
            this.projectMId = data.project_m_id;
            return;
        }
        this.items = {};
        this.deleteItems = {};
        this.deleteFlg = false;
        this.service.resetFieldComp();
        var items = [];
        if (typeof data.items !== 'undefined' && data.items instanceof Array) {
            items = data.items;
        }
        this.seq = 1;
        for (var i = 1; i <= 5; i++) {
            this.items[i] = [];
            this.deleteItems[i] = [];
        }
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (typeof item.id !== 'undefined') {
                item.$type = "put" /* Put */;
            }
            item.$seq = this.seq++;
            item.$editable = true;
            this.items[item.step].push(item);
        }
        if (this.items[5].length === 0) {
            this.items[5].splice(0, 0, Object.assign(new Task(), {
                $seq: this.seq++,
                $editable: false,
                template_type: "inspection" /* inspection */,
                name: '全タスク完了確認'
            }));
        }
        else {
            this.items[5][this.items[5].length - 1].$editable = false;
        }
        this.setCompRec();
    };
    KtsTaskComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    KtsTaskComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
            this.getType();
        }
        else if (e === this.componentName + '#button') {
            // 必須チェック
            var event_1 = this.action.getEvent('taskSave');
            if (typeof event_1.action === 'undefined') {
                return;
            }
            var valid = this.validService.validation('submit', event_1, this.action.getCompRec(), this.msgSnapshot);
            if (!valid.validation) {
                return;
            }
            // 確認のアラートモーダルを表示
            var msg = this.deleteFlg ? this.msgSnapshot['au.COMPONENT.KtsTaskComponent.Modal.save.confirmIncludingDelete'] : this.msgSnapshot['au.COMPONENT.KtsTaskComponent.Modal.save.confirm'];
            this.alertModalService.open({
                message: msg,
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#save#ok',
                        caption: this.msgSnapshot['Modal.button.ok']
                    }, {
                        class: 'cancel',
                        event: this.componentName + '#save#cancel',
                        caption: this.msgSnapshot['Modal.button.cancel']
                    }]
            });
        }
        else if (e === this.componentName + '#save#ok') {
            // タスク保存
            this.action.firstAction('taskSave');
        }
    };
    KtsTaskComponent.prototype.onEvent = function (e1, e2, r) {
        if (e2 === 'add') {
            this.items[r.step].splice(r.index + 1, 0, Object.assign(new Task(), { $seq: this.seq++ }));
        }
        else if (e2 === 'delete') {
            if (typeof this.items[r.step][r.index].id !== 'undefined' && this.items[r.step][r.index].id !== null) {
                this.items[r.step][r.index].$type = "delete" /* Delete */;
                this.deleteItems[r.step].push(this.items[r.step][r.index]);
                this.deleteFlg = true;
            }
            this.items[r.step].splice(r.index, 1);
        }
        else if (e2 === 'up') {
            this.items[r.step].splice(r.index - 1, 2, this.items[r.step][r.index], this.items[r.step][r.index - 1]);
        }
        else if (e2 === 'down') {
            this.items[r.step].splice(r.index, 2, this.items[r.step][r.index + 1], this.items[r.step][r.index]);
        }
        this.setCompRec();
    };
    KtsTaskComponent.prototype.onChange = function (e, r) {
        this.items[r.step][r.index][e.key] = e.val;
        if (typeof e.delFlg !== 'undefined' && e.delFlg === true) {
            this.deleteFlg = true;
        }
        this.setCompRec();
    };
    KtsTaskComponent.prototype.setCompRec = function () {
        var data = [];
        var items = JSOG.parse(JSON.stringify(this.items));
        var deleteData = [];
        var deleteItems = JSOG.parse(JSON.stringify(this.deleteItems));
        for (var i = 1; i <= 5; i++) {
            var order = 1;
            if (items[i]) {
                for (var _i = 0, _a = items[i]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    delete item.$seq;
                    delete item.$editable;
                    item.project_m_id = this.projectMId;
                    item.step = i;
                    item.disp_order = order++;
                    data.push(item);
                }
            }
            if (deleteItems[i]) {
                for (var _b = 0, _c = deleteItems[i]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    delete item.$seq;
                    delete item.$editable;
                    deleteData.push(item);
                }
            }
        }
        this.action.setCompRec(this.componentName, { items: data.concat(deleteData) });
    };
    KtsTaskComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-task',
                    template: "<form id=\"{{ componentName }}\">\n  <div *ngFor=\"let st of step; let stepIndex = index;\" class=\"row\" [class.-mb-1]=\"stepIndex < step.length - 1\">\n    <div class=\"col-sm-12\">\n      <div class=\"filter\">\n        <p class=\"filter_trigger\">\n          <span [class.open]=\"toggles[st.code]\" (click)=\"switchToggle(st.code)\">STEP{{ st.code }}: {{ st.display }}</span>\n        </p>\n        <div class=\"filter_property_toggle -p-1\" [style.display]=\"toggles[st.code] ? 'block': 'none'\">\n          <button *ngIf=\"!readonly && stepIndex === step.length - 1 && items[st.code]?.length == 1\" class=\"addBtn -mt-0 -mb-2\" type=\"button\" (click)=\"onEvent($event, 'add', {step: st.code, index: items[st.code].length - 2})\"></button>\n          <ul class=\"form form-campaign\">\n            <li *ngFor=\"let item of items[st.code]; let index = index;\" class=\"stageFlowPane\">\n              <div *ngIf=\"!readonly && item.$editable\" class=\"stageFlow_arrowsWrapper\">\n                <ul *ngIf=\"stepIndex < step.length - 1\" class=\"stageFlow_arrows\">\n                  <li *ngIf=\"index > 0\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"onEvent($event, 'up', {step: st.code, index: index})\"></a></li>\n                  <li *ngIf=\"index < items[st.code].length - 1\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"onEvent($event, 'down', {step: st.code, index: index})\"></a></li>\n                </ul>\n                <ul *ngIf=\"stepIndex === step.length - 1\" class=\"stageFlow_arrows\">\n                  <li *ngIf=\"index > 0\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"onEvent($event, 'up', {step: st.code, index: index})\"></a></li>\n                  <li *ngIf=\"index < items[st.code].length - 2\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"onEvent($event, 'down', {step: st.code, index: index})\"></a></li>\n                </ul>\n              </div>\n              <div class=\"stageFlowPane_border\">\n                <p *ngIf=\"!readonly && item.$editable\"><a class=\"deleteBtn\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'delete', {step: st.code, index: index})\"></a></p>\n                <div class=\"stageFlowPane_border2\">\n                  <column [key]=\"'forminline'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"{\n                    key: 'template_type',\n                    controlType: 'select',\n                    required: true,\n                    readonly: item.$editable ? readonly : true,\n                    params: {options: (item.$editable ? taskType : inspection)}\n                  }\" [val]=\"item\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, {step: st.code, index: index})\"></column>\n                </div>\n                <p class=\"-mx-1\">{{ taskTemplate[item.template_type]?.note1 }}</p>\n                <p class=\"-mx-1\">{{ taskTemplate[item.template_type]?.note2 }}</p>\n                <div class=\"row -mt-2 -mx-1\">\n                  <div class=\"col-sm-12\">\n                    <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"taskTemplate.name\" [val]=\"item\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, {step: st.code, index: index})\"></column>\n                  </div>\n                </div>\n                <div *ngFor=\"let col of taskTemplate[item.template_type]?.cols\" class=\"row -mt-2 -mx-1\">\n                  <div class=\"col-sm-12\">\n                    <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"col\" [val]=\"taskTemplate[item.template_type]?.values\" [msg]=\"(msg | async)\"></column>\n                  </div>\n                </div>\n                <div class=\"row -mt-2 -mx-1 -mb-1\">\n                  <div class=\"col-sm-12\">\n                    <kts-task-field\n                        [componentName]=\"componentName + '#field' + item.$seq\"\n                        [component]=\"{name: componentName + '#field' + item.$seq, params: {primaryKey: 'id', maxRows: '10'}}\"\n                        [fieldCols]=\"taskTemplate.field\"\n                        [vals]=\"item\"\n                        (changeField)=\"onChange($event, {step: st.code, index: index})\"></kts-task-field>\n                  </div>\n                </div>\n              </div>\n              <button *ngIf=\"index < items[st.code].length - 1 && !readonly && item.$editable\" class=\"addBtn -mt-2\" type=\"button\" (click)=\"onEvent($event, 'add', {step: st.code, index: index})\"></button>\n            </li>\n          </ul>\n          <button *ngIf=\"!readonly && stepIndex < step.length - 1\" class=\"addBtn -mt-0\" [class.-mt-2]=\"items[st.code]?.length > 0\" type=\"button\" (click)=\"onEvent($event, 'add', {step: st.code, index: items[st.code].length - 1})\"></button>\n        </div>\n      </div>\n    </div>\n  </div>\n  <div class=\"row -mt-1\">\n    <div class=\"col-sm-12\">\n      <btn [componentName]=\"componentName + '#button'\"\n           [component]=\"{\n             params: {\n               buttons: [{\n                 type: 'button',\n                 event: componentName + '#button',\n                 caption: (msg | async)['Button_save']\n               }]\n             }\n           }\"></btn>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsTaskComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsTaskService },
        { type: AlertModalService },
        { type: ValidationService }
    ]; };
    return KtsTaskComponent;
}(ContentBaseComponent));
export { KtsTaskComponent };
//# sourceMappingURL=task.component.js.map